import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "vue-messages" }
const _hoisted_2 = { class: "vue-messages__item__inner" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messageList, (message, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass(["vue-messages__item", [message.getType(), { removing: message.isRemoving()}]])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            innerHTML: message.getMessage()
          }, null, 8, _hoisted_3),
          _createElementVNode("img", {
            src: "https://cdn1.idek.cz/file/close-white-3472c692.svg",
            width: "30",
            height: "30",
            onClick: ($event: any) => (_ctx.removeMessage(message))
          }, null, 8, _hoisted_4)
        ])
      ], 2))
    }), 128))
  ]))
}